export type SendCodeBasePayload = {
  areaCode: string
  phone: string
  languageCode: string
  msgType: number
  smsBusinessType: number
  applicationType: number
}

export type GeetestValidatePayload = {
  geetest_validate?: string
  geetest_challenge?: string
  captcha_output: string
  lot_number: string
  pass_token: string
  gen_time: string
}

export const buildGeetestSendCodePayload = (
  basePayload: SendCodeBasePayload,
  validatePayload: GeetestValidatePayload,
) => ({
  ...basePayload,
  GeetestValidate: validatePayload.geetest_validate,
  GeetestChallenge: validatePayload.geetest_challenge,
  captcha_output: validatePayload.captcha_output,
  lot_number: validatePayload.lot_number,
  pass_token: validatePayload.pass_token,
  gen_time: validatePayload.gen_time,
})

export const buildGraphCodeSendCodePayload = (basePayload: SendCodeBasePayload, graphCode: string) => ({
  ...basePayload,
  graphCode,
})
